import { Config } from "../landing-config";
import { ico_pink } from "../map-config";


const maxFileRows = 500;
export const RETE_SECONDARIA_CONFIG: Config = {
    data: {
        route: 'rete-secondaria',
        page_title: 'Rete Secondaria | Open Fiber',
        service_title: 'Rete Secondaria',
        service_description: '',
        service_name: '',
        service_slug: 'retesecondaria',
        errorTimeout: 0,
		feasibilityModelSingle: false,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '/servizioretesecondaria/massivep2p/detail',
                massiveUploadPath: '/point/servizioretesecondaria/massivep2p/upload',
                massiveDownloadPath: '/servizioretesecondaria/data/massive/import.xlsx',
                massiveP2pSalesforcePath: '/servizioretesecondaria/massivep2p/send-to-salesforce',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/point/servizioretesecondaria/p2p',
			bboxPath: null,
			buildingSearchParams: null
        },
        dynamic_aend_name: ''
    },
    multiple_points: {
        variable: false,
        max: 2,
        points: {
            b_end: {
                default_method: 'rete',
                switch_methods: true,
                address: false,
                pop: false,
                poi: false,
                pfs: false,
                roe: false,
                coordinates: false,
                id_building: false,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
				city_building: false,
				city_pfs: false,
				city_roe: true,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
				punti_intermedi: false,
				rete: true,
                pop_pcn_xpop: false,
            },
            a_end: {
                default_method: 'rete',
                switch_methods: true,
                address: false,
                pop: false,
                poi: false,
                pfs: false,
                roe: false,
                coordinates: false,
                id_building: false,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
				city_building: false,
				city_pfs: true,
				city_roe: false,
                id_healthcare: false,
                upload: false,
                popAndPoiAutocomplete: false,
				punti_intermedi: false,
				rete: true,
                pop_pcn_xpop: false,
            }
        },
        initial_points: ['b_end', 'a_end']
    },
    map: {
        map_events: ['zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: true,
        marker_default_icon: ico_pink,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: false,
        id_bts_noa: false,
        id_bts_building: false,
        id_school: false,
        id_healthcare: false,
        punti_intermedi: false,
        pop_pcn_xpop: false,
    },
    area_types: ['CoveredAGF'],
    area_types_short: null,
    kml: false,
    pop: {
        load: false,
        view_initial: false,
        click: false,
        loadCities: false
    },
    pcn: {
        load: false,
        view_initial: false,
        click: false
    },
    pop_agf: {
        load: false,
        view_initial: false,
        click: false
    },
    poi: {
        load: false,
        view_initial: false,
        click: false,
        x_pop: false,
        is_registered: false,
        custom_research_method: null,
        loadCities: false
    },
    pfs: {
        load: true,
        view_initial: false,
        click: true,
        type: 'PFS'
    },
    roe: {
        load: true,
        view_initial: false,
        click: true,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: false,
        click: false,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: false,
        click: false,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: false,
        types: null
    },
    punti_intermedi: {
        load: false,
        types: null
    },
    pop_pcn_xpop: {
        load: false,
        types: null
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}